<div class="layout-row full-height padding-10">

  <div class="flex-30 layout-column layout-align-center-start">
    <!--Service ID-->
    <div class="layout-row layout-align-start-center text-ellipsis">
      <app-bringoz-state-link *ngIf="relation.details.serviceType === serviceTypes.Delivery"
                              class="flex text-ellipsis"
                              [state]="'service.delivery.info'"
                              [params]="{id: relation.details.serviceId}"
                              [permission]="'services.get'"
                              [text]="isDisplayExternal && relation.details.serviceExternalId ? relation.details.serviceExternalId : relation.details.serviceId">
      </app-bringoz-state-link>

      <app-bringoz-state-link *ngIf="relation.details.serviceType === serviceTypes.Operation"
                              class="flex text-ellipsis"
                              [state]="'service.operation.info'"
                              [params]="{id: relation.details.serviceId}"
                              [permission]="'services.get'"
                              [text]="isDisplayExternal && relation.details.serviceExternalId ? relation.details.serviceExternalId: relation.details.serviceId">
      </app-bringoz-state-link>


    </div>

    <!--Relation Type -->
    <div class="layout-row layout-align-start-center text-ellipsis">
      <span class="br-caption-2">{{ relation.type | translate }}</span>
    </div>

    <!--Purpose / Amount Of Related Tasks-->
    <div class="layout-row layout-align-start-center">

      <app-task-purpose [purpose]="relation.details.taskPurpose"></app-task-purpose>

      <span class="flex"></span>

      <app-relations-indicator [count]="relation.details.amountOfRelatedTasks"></app-relations-indicator>

    </div>

    <!--Agent Tags -->
    <div *ngIf="relation.details?.agentTags?.length" class="layout-row layout-align-start-center">

      <app-bringoz-tags [tags]="relation.details.agentTags"
                        maxTags="2">
      </app-bringoz-tags>

    </div>
  </div>

  <hr class="margin-0 secondary-101">

  <div class="layout-column flex">

    <!--Time Window & SLA-->
    <div class="flex layout-row layout-align-start-center info-row">


      <bringoz-icon iconName="time-window-outline" [ngbTooltip]="'Task time window' | translate" fill="#7E7E7E"
                    openDelay="300"
                    triggers="hover">
      </bringoz-icon>
      <span class="br-body-1 font-weight-400">
        {{ {notBefore: relation.details.taskNotBefore, notAfter: relation.details.taskNotAfter} | timeWindow }}
      </span>
    </div>

    <!--Location-->
    <div *ngIf="!!relation.details?.address" class="layout-row layout-align-start-center info-row">
      <bringoz-icon iconName="location-pin-outline" fill="#7E7E7E"></bringoz-icon>
      <span class="flex br-body-1 font-weight-400 text-ellipsis"
            [ngbTooltip]="relation.details.address | bringozAddress"
            openDelay="300" triggers="hover">
        {{ relation.details.address | bringozAddress }}</span>
    </div>


    <!--packages-->
    <div *ngIf="!!relation.details?.packageList" class="layout-row layout-align-start-center info-row">
      <div class="layout-row layout-align-start-center full-width">

        <app-service-packed-indication
          *ngIf="!!relation.details.packageList?.length && !!relation.details.packageList[0]?.items?.length"
          [packageList]="relation.details.packageList"
          [serviceType]="relation.details.taskPurpose">

        </app-service-packed-indication>

        <div class="margin-left-5 layout-row layout-align-start-center">
          <bringoz-icon iconName="weight" class="secondary-100"></bringoz-icon>
          <span>{{ relation.details.packageList[0].items | servicePackageWeight: true }}</span>
        </div>
      </div>
    </div>

    <!--Assigned Agent-->
    <div *ngIf="relation.details.agentId"
         class="layout-row layout-align-start-center info-row">

      <app-bringoz-state-link class="flex text-ellipsis"
                              [state]="'agents-itinerary.list'"
                              [permission]="'driver.itinerary.get'"
                              [params]="{agentId : relation.details.agentId}"
                              [text]="relation.details.agentFirstName + ' ' +  relation.details.agentLastName">
      </app-bringoz-state-link>


    </div>

  </div>

  <div class="flex-15 layout-column layout-align-center-center">
    <!--ETA-->
    <div class="layout-row layout-align-start-center" *ngIf="relation.details.status !== 'CourierDeparted'">
      <span class="br-body-1 font-weight-400"
            [ngClass]="{'eta-late':relation.details.late > 0}">{{ relation.details | bringozTime: 'eta' }}
      </span>
      <bringoz-icon *ngIf="relation.details.late > 0" fill="#7E7E7E" iconName="error"
                    class="animated infinite flash"></bringoz-icon>
    </div>
    <div class="layout-row layout-align-start-center" *ngIf="relation.details.status === 'CourierDeparted'">
      <span class="br-body-1 font-weight-400">
        {{ relation.details | bringozTime: 'timeOfDeparture' }}
      </span>
    </div>
    <app-bringoz-status-tag [status]="relation.details.status" [isSmall]="true"></app-bringoz-status-tag>
  </div>
</div>
